import { useSearchParams } from 'react-router-dom';
import { REPORT_PRESETS, rangeParams, readDateRange, type DateRange } from '../date-range';

/** Keep a call-history link reproducible, including the provider and page. */
export default function useCallHistory() {
  const [params, setParams] = useSearchParams();
  const requestedView = params.get('call_view') || 'ad_calls';
  const view = ['ad_calls', 'scoring_and_coaching', 'ghl_activity'].includes(requestedView) ? requestedView : 'ad_calls';
  const requestedPage = Number(params.get('call_page') || 1);
  const page = Number.isSafeInteger(requestedPage) && requestedPage > 0 && requestedPage <= 1000000 ? requestedPage : 1;
  function update(fields: Record<string, string | null>) {
    setParams(current => {
      const next = new URLSearchParams(current);
      for (const [key, value] of Object.entries(fields)) {
        if (value == null || value === '') next.delete(key); else next.set(key, value);
      }
      return next;
    }, { replace: true });
  }
  return {
    view, page,
    query: (params.get('call_q') || '').slice(0, 200),
    allHistory: params.get('call_all') === '1',
    // LSA territory and row filter stay in the link too, so a reload keeps them (Shawn, 2026-10-28).
    territory: /^\d{10}$/.test(params.get('territory') || '') ? params.get('territory') as string : '',
    show: (params.get('show') || '').slice(0, 40),
    range: readDateRange(params, REPORT_PRESETS, '30d', 36500),
    setView: (next: string) => update({ call_view: next === 'ad_calls' ? null : next, call_page: null, call_q: null }),
    setQuery: (next: string) => update({ call_q: next.slice(0, 200), call_page: null }),
    setTerritory: (next: string) => update({ territory: next, call_page: null }),
    setShow: (next: string) => update({ show: next, call_page: null }),
    setPage: (next: number) => update({ call_page: next > 1 ? String(next) : null }),
    setAllHistory: (next: boolean) => update({ call_all: next ? '1' : null, call_page: null }),
    setRange: (next: DateRange) => update({ ...rangeParams(next), call_all: null, call_page: null }),
  };
}
